import { render, staticRenderFns } from "./ItemOptionWeight.vue?vue&type=template&id=7e0f2fa9&scoped=true&"
import script from "./ItemOptionWeight.vue?vue&type=script&lang=js&"
export * from "./ItemOptionWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0f2fa9",
  null
  
)

export default component.exports